import { render, staticRenderFns } from "./hazardFacilityDetail.vue?vue&type=template&id=2b96b5b0"
import script from "./hazardFacilityDetail.vue?vue&type=script&lang=js"
export * from "./hazardFacilityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b96b5b0')) {
      api.createRecord('2b96b5b0', component.options)
    } else {
      api.reload('2b96b5b0', component.options)
    }
    module.hot.accept("./hazardFacilityDetail.vue?vue&type=template&id=2b96b5b0", function () {
      api.rerender('2b96b5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/hcf/hazardFacilityDetail.vue"
export default component.exports